export const SET_RECOMMENDATIONS = 'recommendations/SET_RECOMMENDATIONS';
export const SET_RECOMMENDATION_UPDATE = 'recommendations/SET_RECOMMENDATION_UPDATE';
export const SET_FEEDBACK_OPTED_OUT = 'recommendations/SET_FEEDBACK_OPTED_OUT';
export const SET_RECOMMENDATION_FEEDBACK = 'recommendations/SET_RECOMMENDATION_FEEDBACK';

export const setRecommendations = payload => ({
  type: SET_RECOMMENDATIONS,
  payload,
});

export const setRecommendationUpdate = (
  action,
  declaration_id, reason = null,
  dismissed_user = null,
  dismissed_time = null
) => ({
  type: SET_RECOMMENDATION_UPDATE,
  payload: { action, declaration_id, reason, dismissed_user, dismissed_time },
});

export const setFeedbackOptedOut = payload => ({
  type: SET_FEEDBACK_OPTED_OUT,
  payload,
});

export const setRecommendationFeedback = (declaration_id, up, down, my_rating) => ({
  type: SET_RECOMMENDATION_FEEDBACK,
  payload: { declaration_id, up, down, my_rating },
});
